import { useState, useRef } from 'react';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Modal, Checkbox } from 'antd';
import React from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { ValidationRule } from 'antd/lib/form';
import { InputProps } from 'antd/lib/input/Input';

import style from './index.less';

const useEditModal = () => {
  const [editItem, setEditItem] = useState<Record<string, unknown>>({});
  const [editVisible, setEditVisible] = useState(false);

  const handleAdd = () => {
    setEditItem({});
    setEditVisible(true);
  };
  const handleEdit = (value: string | number, options: Record<string, unknown>) => {
    setEditItem(options);
    setEditVisible(true);
  };
  return {
    editItem,
    setEditItem,
    editVisible,
    setEditVisible,
    handleAdd,
    handleEdit
  };
};

interface DeleteContentProps {
  title?: string;
  content?: string;
}

const DeleteContent = (props: DeleteContentProps): JSX.Element => {
  const { title, content } = props;
  return <>
    <ExclamationCircleFilled className={style.deleteIcon} />
    <h3 className={style.deleteTitle}>{title}</h3>
    <p>{content}</p>
  </>;
};

interface EditModalProps extends FormComponentProps {
  title?: string;
  label?: string;
  visible: boolean;
  onOk: (value: number | string) => void;
  value: number | string;
  closeModal: () => void;
  inputProps: InputProps;
  rules?: Array<ValidationRule>;
  showCheckBox?: boolean;
  check?: boolean;
  checkLabel?: string;
  checkTxt?: string;
  newModalStyle?: boolean;
}

const EditModal = ({
  title,
  visible,
  onOk,
  closeModal,
  label,
  inputProps,
  value,
  form,
  rules,
  showCheckBox = false,
  check,
  checkLabel,
  checkTxt,
  newModalStyle = false
}: EditModalProps): JSX.Element => {
  const { getFieldDecorator } = form;
  const inputRef = useRef<Input>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e && e.keyCode === 13) {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    form.validateFields((err, values) => {
      if (!err) {
        if (showCheckBox) {
          onOk(values);
          return;
        }
        onOk(values.value);
      }
    });
  };

  return (
    <Modal
      title={title}
      open={visible}
      onOk={handleSubmit}
      onCancel={closeModal}
      destroyOnClose={true}
      okText={'确定'}
      cancelText={'取消'}
      className={style[`${newModalStyle ? 'newModal' : ''}`]}>
      <div className={style.form}>
        <Form layout="horizontal" style={{ flex: '1 1 auto' }}>
          <Form.Item
            label={label || '名称'}
            labelCol={newModalStyle ? undefined : { span: 4 }}
            wrapperCol={newModalStyle ? undefined : { span: 20 }}>
            {getFieldDecorator('value', {
              initialValue: value,
              rules: rules
            })(<Input placeholder={'请输入'} ref={inputRef} onKeyDown={handleKeyDown} {...inputProps} />)}
          </Form.Item>
          {showCheckBox ? (
            <Form.Item label={checkLabel} className={style.checkBox}>
              {getFieldDecorator('check', {
                initialValue: check,
                valuePropName: 'checked'
              })(<Checkbox>{checkTxt}</Checkbox>)}
            </Form.Item>
          ) : null}
        </Form>
      </div>
    </Modal>
  );
};

const EditModalForm = Form.create<EditModalProps>({ name: 'summary' })(EditModal);

export { useEditModal, EditModalForm, DeleteContent };
